import { Component, OnInit, OnDestroy } from '@angular/core';

@Component({
  selector: 'app-hero',
  templateUrl: './hero.component.html',
  styleUrls: ['./hero.component.scss']
})
export class HeroComponent implements OnInit, OnDestroy {

  carouselImages = [
    'assets/images/captura1.png',
    'assets/images/captura2.png',
    'assets/images/captura3.png',
    'assets/images/captura4.png',
    'assets/images/captura5.png',
    'assets/images/captura6.png',
    'assets/images/captura7.png'
  ];
  activeIndex = 0;
  private carouselTimer: any;

  constructor() { }

  ngOnInit(): void {
    this.carouselTimer = setInterval(() => this.nextImage(), 5000);
  }

  ngOnDestroy(): void {
    clearInterval(this.carouselTimer);
  }

  prevImage(): void {
    this.activeIndex = (this.activeIndex - 1 + this.carouselImages.length) % this.carouselImages.length;
  }

  nextImage(): void {
    this.activeIndex = (this.activeIndex + 1) % this.carouselImages.length;
  }

  goTo(index: number): void {
    this.activeIndex = index;
  }

  get currentImage(): string {
    return this.carouselImages[this.activeIndex];
  }
}
